var map = {
	"./image1.png": 60064,
	"./image10.png": 15586,
	"./image2.png": 38395,
	"./image3.png": 23570,
	"./image4.png": 28429,
	"./image5.png": 74532,
	"./image6.png": 11391,
	"./image7.png": 14454,
	"./image8.png": 91761,
	"./image9.png": 81544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89176;